import { Component, OnInit, Input } from '@angular/core';

import { ReportDataType } from '@enums/report-data-type.enum';
import { ReportVariation } from '@classes/report/report-variation';

@Component({
    selector: 'app-report-datatable',
    templateUrl: './report-datatable.component.html',
    styleUrls: ['./report-datatable.component.scss']
})
export class ReportDatatableComponent implements OnInit {
    @Input() variation: ReportVariation;

    dataType = ReportDataType;
    lineClass = "deep-0";

    ngOnInit() {
        if (document.querySelector(`#print-view`))
        {
            const lineCount = this.variation.stacks[0].datasets.length;
            if (lineCount >= 6) this.lineClass = "deep-0 line6";
            if (lineCount >= 8) this.lineClass = "deep-0 line8";
        }
    }
}
